/**
 * Meta Pixel helper. Pixel base script + PageView fire from index.html
 * (Pixel ID 1658200818776940). This module wraps custom event tracking
 * with a window guard so calls no-op cleanly when the pixel hasn't loaded
 * (ad-blocker, network error, SSR).
 */

function track(event, params) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  if (params) window.fbq('track', event, params)
  else window.fbq('track', event)
}

export const pixel = {
  trackRegistration() {
    track('CompleteRegistration')
  },
  trackSubscribe(value, currency = 'USD') {
    track('Subscribe', { value, currency })
  },
}
